import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { interval, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { ActiveDowntimeDTO, DowntimeRepositoryService } from "../services/downtime-repository.service";

@Component({
    selector: "app-maintenance",
    templateUrl: "./maintenance.component.html",
    styleUrls: ["./maintenance.component.scss"],
  })
  export class MaintenanceComponent implements OnInit, OnDestroy {
    activeDowntime: ActiveDowntimeDTO | null = null;
    isLoading: boolean = true;
    private unsubscribe: Subject<void> = new Subject<void>();

    constructor(
      private downtimeService: DowntimeRepositoryService,
      private router: Router
    ) {}

    ngOnInit() {
      this.checkActiveDowntime();
      // Auto-refresh every 60 seconds to detect when downtime ends
      interval(60000)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(() => this.checkActiveDowntime());
    }

    ngOnDestroy() {
      this.unsubscribe.next();
      this.unsubscribe.complete();
    }

    private checkActiveDowntime(): void {
      this.downtimeService.getActive()
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          (data) => {
            this.isLoading = false;
            if (data) {
              this.activeDowntime = data;
            } else {
              // Downtime ended - full page reload to trigger fresh MSAL auth flow
              window.location.href = '/';
            }
          },
          (error) => {
            this.isLoading = false;
            // If API is truly down, show generic message
            console.error('Error checking downtime status:', error);
          }
        );
    }
  }